import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { no } from "translations/no";
import { se } from "translations/se";
import { log, LogLevel } from "logging/datadogBrowserLogs";

export const resources = {
  no: {
    translation: no,
  },
  se: {
    translation: se,
  },
} as const;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "no",
    lng: localStorage.getItem("Language") || "no",
    showSupportNotice: false,
  })
  .catch((error) => {
    log(LogLevel.error, "i18n.js", `i18next initialization failed: ${error} `);
  });

export default i18n;
